import React from "react";
import { Map } from "./map";

const markers = [
  {
    left: "82%",
    top: "50%",
    country: "Taiwan",
    continent: "Asian Pacific (APAC) ",
  },
  {
    left: "86%",
    top: "42%",
    country: "Japan",
    continent: "Asian Pacific (APAC) ",
  },
  {
    left: "82.6%",
    top: "42%",
    country: "Südkorea",
    continent: "Asian Pacific (APAC) ",
  },
  {
    left: "78%",
    top: "57%",
    country: "Vietnam",
    continent: "Asian Pacific (APAC) ",
  },
  {
    left: "56.6%",
    top: "42.2%",
    country: "Türkei",
    continent: "Central Asia / Middle East / Africa (CAMEA)",
  },
  {
    left: "50.6%",
    top: "36.4%",
    country: "Österreich",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "53.6%",
    top: "39.3%",
    country: "Bulgarien",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "50.3%",
    top: "38.6%",
    country: "Kroatien",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "53%",
    top: "27.3%",
    country: "Estland",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "53%",
    top: "23%",
    country: "Finnland",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "49%",
    top: "33.8%",
    country: "Deutschland",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "53.5%",
    top: "29.3%",
    country: "Lettland",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "52.6%",
    top: "31%",
    country: "Litauen",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "48.6%",
    top: "27%",
    country: "Norwegen",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "52.2%",
    top: "33.5%",
    country: "Polen",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "53.6%",
    top: "37.4%",
    country: "Rumänien",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "50.6%",
    top: "25%",
    country: "Schweden",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "48.4%",
    top: "38.7%",
    country: "Schweiz",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "19%",
    top: "23.1%",
    country: "Kanada",
    continent: "North America (NA)",
  },
  {
    left: "28%",
    top: "82%",
    country: "Argentinien",
    continent: "Southern Europe and Latin America (SELA)",
  },
  {
    left: "31%",
    top: "68.2%",
    country: "Brasilien",
    continent: "Southern Europe and Latin America (SELA)",
  },
  {
    left: "26.4%",
    top: "85.5%",
    country: "Chile",
    continent: "Southern Europe and Latin America (SELA)",
  },
  {
    left: "25.4%",
    top: "62.4%",
    country: "Kolumbien",
    continent: "Southern Europe and Latin America (SELA)",
  },
  {
    left: "22%",
    top: "58.7%",
    country: "Costa Rica",
    continent: "Southern Europe and Latin America (SELA)",
  },
  {
    left: "52.6%",
    top: "43.8%",
    country: "Griechenland",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "50.3%",
    top: "41.6%",
    country: "Italien",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "43.8%",
    top: "41.2%",
    country: "Portugal",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "46.2%",
    top: "41.5%",
    country: "Spanien",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "31%",
    top: "81.3%",
    country: "Uruguay",
    continent: "Southern Europe and Latin America (SELA)",
  },
  {
    left: "46%",
    top: "37%",
    country: "Frankreich",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "44%",
    top: "33%",
    country: "Irland",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "46.4%",
    top: "33%",
    country: "Großbritannien",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "47.6%",
    top: "34%",
    country: "Niederlande",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "47.4%",
    top: "35.8%",
    country: "Belgien",
    continent: "Central & Northern Europe (CNE)",
  },
  {
    left: "48.6%",
    top: "36.5%",
    country: "Luxenburg",
    continent: "Central & Northern Europe (CNE)",
  },
];

export const MapSection: React.FC = () => <Map markers={markers} />;
